const fighterDesigns = [
  {
    name: "SAAB Draken - Dragon Knights",
    fileName: "draken_dragon_knights",
    videoUrl: "https://youtu.be/jtQkTUamiQ4",
    image: "draken_dragon_knights.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/xphlm",
  },
  {
    name: "SAAB Draken - Ostarrichi",
    fileName: "draken_ostarrichi",
    videoUrl: "https://youtu.be/jtQkTUamiQ4",
    image: "draken_ostarrichi.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/noiigi",
  },
  {
    name: "SAAB Draken - Johan Blue",
    fileName: "draken_johan_blue",
    videoUrl: "https://youtu.be/jtQkTUamiQ4",
    image: "draken_johan_blue.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/gxuxvw",
  },
  {
    name: "SAAB Draken - Yellow Marlins",
    fileName: "draken_yellow_marlins",
    videoUrl: "https://youtu.be/jtQkTUamiQ4",
    image: "draken_yellow_marlins.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/jdpjwu",
  },
  {
    name: "F-35A Lightening",
    fileName: "f-35a-v2",
    videoUrl: "https://www.youtube.com/watch?v=i75zrSkkyAo",
    roundel: "us_white",
    image: "f35_v2.jpg",
    gumroadPermalink: "f35a_editor",
    gumroadProductId: "0gNcDws_arvNoNb1yGMJQA==",
  },
  {
    name: "F/A-18 Blue Angels",
    fileName: "f-18-blueangels",
    videoUrl: "https://youtu.be/81e1D_vBo2o",
    image: "blueangels.jpg",
    number: 5,
    minNumber: 1,
    maxNumber: 7,
    version: "v2",
    roundelEditable: false,
    gumroadPermalink: "blue-angels-editor",
    gumroadProductId: "mrxed-PJOF-2dmMVNoboRA==",
  },
  {
    name: "Aerorigami: F-16 Series",
    fileName: "aerorigami_vol1",
    image: "aerorigami_vol1.jpg",
    bannerLink: "https://f16.origami-skin.com"
  },
  {
    name: "KF-21 001",
    fileName: "kf21_001",
    videoUrl: "https://youtu.be/zYzEnm_RDtw",
    image: "kf21_001.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/jxeuun"
  },
  {
    name: "KF-21 002",
    fileName: "kf21_002",
    videoUrl: "https://youtu.be/zYzEnm_RDtw",
    image: "kf21_002.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/fqgyy"
  },
  {
    name: "KF-21 003",
    fileName: "kf21_003",
    videoUrl: "https://youtu.be/zYzEnm_RDtw",
    image: "kf21_003.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/akqaik"
  },
  {
    name: "KF-21 004",
    fileName: "kf21_004",
    videoUrl: "https://youtu.be/zYzEnm_RDtw",
    image: "kf21_004.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/trwnmk"
  },
  {
    name: "KF-21 005",
    fileName: "kf21_005",
    videoUrl: "https://youtu.be/zYzEnm_RDtw",
    image: "kf21_005.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/gafsf"
  },
  {
    name: "KF-21 006",
    fileName: "kf21_006",
    videoUrl: "https://youtu.be/zYzEnm_RDtw",
    image: "kf21_006.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/tdyyyl"
  },
  {
    name: "Dassault Rafale",
    fileName: "rafale_v2",
    videoUrl: "https://www.youtube.com/watch?v=-9xUppfvIpM",
    image: "rafale_v2.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/nvcvni"
  },
  {
    name: "Rafale NATO Tiger 2013",
    fileName: "rafale_nato2013",
    videoUrl: "https://www.youtube.com/watch?v=-9xUppfvIpM",
    image: "rafale_nato2013.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/fdcvfwt"
  },
  {
    name: "SU-57 Top Gun 5th-Gen Fighter",
    fileName: "su57_v2_topgun",
    videoUrl: "https://www.youtube.com/watch?v=qwO-xDDkoT0",
    image: "su57_v2_topgun.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/ikhlq"
  },
  {
    name: "SU-57 White Shark",
    fileName: "su57_v2_whiteshark",
    videoUrl: "https://www.youtube.com/watch?v=qwO-xDDkoT0",
    image: "su57_v2_whiteshark.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/htqfok"
  },
  {
    name: "SU-57 Pixel Camouflage",
    fileName: "su57_v2_pixel",
    videoUrl: "https://www.youtube.com/watch?v=qwO-xDDkoT0",
    image: "su57_v2_pixel.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/jqgwoa"
  },
  {
    name: "SU-57 Mesh Camouflage",
    fileName: "su57_v2_mesh",
    videoUrl: "https://www.youtube.com/watch?v=qwO-xDDkoT0",
    image: "su57_v2_mesh.jpg",
    gumroadStoreLink: "https://origamiskin.gumroad.com/l/juocsu"
  },
  {
    name: "F-16 Thunderbirds",
    fileName: "f16_tb",
    videoUrl: "https://youtu.be/FE3iVoEKXqQ",
    image: "f16_tb.jpg",
    patreonStoreLink:
      "https://www.patreon.com/posts/air-force-elite-129743710?utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=postshare_creator&utm_content=join_link",
  },
  {
    name: "FA-50 KR",
    fileName: "fa-50_kr",
    videoUrl: "https://youtu.be/XBTr62vtcR8",
    image: "fa-50_ko.jpg",
    patreonStoreLink:
      "https://www.patreon.com/posts/fa-50-fighting-126538345?utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=postshare_creator&utm_content=join_link",
  },
  {
    name: "FA-50 PH",
    fileName: "fa-50_ph",
    videoUrl: "https://youtu.be/XBTr62vtcR8",
    image: "fa-50_ph.jpg",
    patreonStoreLink:
      "https://www.patreon.com/posts/fa-50-fighting-126538345?utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=postshare_creator&utm_content=join_link",
  },
  {
    name: "F/A-18 Jolly Rogers",
    fileName: "f-18_02",
    videoUrl: "https://youtu.be/s5d3rZZnR_o",
    roundel: "us",
    image: "f-18_02.jpg",
  },
  // {
  //   name: "KF-21 001",
  //   fileName: "kf-21_01",
  //   videoUrl: "https://youtu.be/zYzEnm_RDtw",
  //   image: "kf-21_01.jpg",
  //   patreonStoreLink:
  //     "https://www.patreon.com/posts/fold-kf-21-107221142?utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=postshare_creator&utm_content=join_link",
  // },
  // {
  //   name: "KF-21 006",
  //   fileName: "kf-21_06",
  //   videoUrl: "https://youtu.be/zYzEnm_RDtw",
  //   image: "kf-21_06.jpg",
  //   patreonStoreLink:
  //     "https://www.patreon.com/OrigamiSkin/shop/kf-21-prototype-006-253924?utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=productshare_fan&utm_content=join_link",
  // },
  {
    name: "Mig-29",
    fileName: "mig-29_01",
    videoUrl: "https://youtu.be/nLPbr1X8KmE",
    roundel: "soviet",
    image: "mig-29_01.jpg",
  },
  // {
  //   name: "SAAB J-35Ö Mk.II Draken 'Ostarrichi'",
  //   fileName: "draken_03",
  //   videoUrl: "https://youtu.be/VGiREiLINwg",
  //   roundel: "austria",
  //   numberEditable: true,
  //   number: "08",
  //   image: "draken_03.jpg",
  // },
  // {
  //   name: "Origami SAAB J35J Draken 'Johan Blå 40'",
  //   fileName: "draken_04",
  //   videoUrl: "https://youtu.be/VGiREiLINwg",
  //   roundel: "empty",
  //   image: "draken_04.jpg",
  // },
  // {
  //   name: "SAAB 35FS Draken",
  //   fileName: "draken_01",
  //   videoUrl: "https://youtu.be/VGiREiLINwg",
  //   roundel: "austria",
  //   numberEditable: true,
  //   number: "09",
  //   image: "draken_01.jpg",
  // },
  {
    name: "Eurofighter Typhoon",
    fileName: "typhoon_02",
    videoUrl: "https://youtu.be/-JNwmlhx1aM",
    image: "typhoon_02.jpg",
    roundelEditable: false,
  },
  {
    name: "Missiles",
    fileName: "missiles_01",
    videoUrl: "https://youtu.be/-JNwmlhx1aM?t=749",
    image: "missiles_01.jpg",
    roundelEditable: false,
    symbolColorSelectable: true,
  },
  {
    name: "Eurofighter Typhoon",
    fileName: "typhoon_01",
    videoUrl: "https://youtu.be/-JNwmlhx1aM",
    image: "typhoon_01.jpg",
    roundelEditable: false,
  },
  {
    name: "Mitsubishi F-2",
    fileName: "f-2_01",
    videoUrl: "https://youtu.be/IXy_VleKhx4",
    roundel: "japan",
    image: "f-2_01.jpg",
  },
  {
    name: "F/A-18E",
    fileName: "f-18_01",
    videoUrl: "https://youtu.be/s5d3rZZnR_o",
    roundel: "us_low",
    image: "f-18_01.jpg",
  },
  {
    name: "SAAB J-35F Draken",
    fileName: "draken_02",
    videoUrl: "https://youtu.be/VGiREiLINwg",
    roundel: "sweden",
    numberEditable: true,
    number: "11",
    image: "draken_02.jpg",
  },
  {
    name: "F-35A Lightening",
    fileName: "f-35a_01",
    videoUrl: "https://youtu.be/EuK026NHmg0",
    roundel: "us_white",
    image: "f35_01.jpg",
  },
  {
    name: "F-22 Raptor",
    fileName: "f-22_01",
    videoUrl: "https://youtu.be/_P1geI-V62M",
    roundel: "us_white",
    image: "f22_01.jpg",
  },
  {
    name: "Dasault Rafale Qatar",
    fileName: "rafale_04",
    videoUrl: "https://youtu.be/m1f-nqIKikE",
    roundel: "qatar",
    image: "rafale_camo.jpg",
  },
  {
    name: "Dasault Rafale Tiger",
    fileName: "rafale_03",
    videoUrl: "https://youtu.be/m1f-nqIKikE",
    roundel: "empty",
    image: "rafale_tiger.jpg",
  },
  {
    name: "Dasault Rafale",
    fileName: "rafale_01",
    videoUrl: "https://youtu.be/m1f-nqIKikE",
    roundel: "france",
    image: "rafale_01.jpg",
  },
  {
    name: "F-16 Camouflage",
    fileName: "f-16_01",
    videoUrl: "https://youtu.be/qThCN8sauFE",
    roundel: "us_white",
    image: "f16_01.jpg",
  },
  {
    name: "F-16",
    fileName: "f-16_02",
    videoUrl: "https://youtu.be/qThCN8sauFE",
    roundel: "us_white",
    image: "f16_02.jpg",
  },
  {
    name: "F-16",
    fileName: "f-16_03",
    videoUrl: "https://youtu.be/qThCN8sauFE",
    roundel: "us_white",
    image: "f16_03.jpg",
  },
  {
    name: "SU-57",
    fileName: "su-57_01",
    videoUrl: "https://youtu.be/PuMp4INOloU",
    roundel: "soviet",
    image: "su57_01.jpg",
  },
  {
    name: "SU-57",
    fileName: "su-57_02",
    videoUrl: "https://youtu.be/PuMp4INOloU",
    roundel: "soviet",
    image: "su57_02.jpg",
  },
  {
    name: "Mirage",
    fileName: "mirage_01",
    videoUrl: "https://youtu.be/2ZnIgt4x4Yg",
    roundel: "france",
    image: "mirage_01.jpg",
  },
];

function findFighterDesign(fighter) {
  if (!fighter) return null;
  return fighterDesigns.find((each) => each.fileName === fighter);
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

function getRandomFighterDesign() {
  let i = getRandomInt(0, fighterDesigns.length);
  return fighterDesigns[i];
}

function getLastFighterDesign() {
  return fighterDesigns[fighterDesigns.length - 1];
}

export {
  fighterDesigns,
  findFighterDesign,
  getRandomFighterDesign,
  getLastFighterDesign,
};
